import React from 'react';

import { navigationMessages } from '../../../translates/navigationMessages';
import { useIntlReexport } from '../../hooks/useIntlReexport';
import { BasicNavigationButtonProps } from './model';
import { NavigationBar } from '@ael/shared-components-library';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

export const FinishNavigationButton: React.FC<BasicNavigationButtonProps> = (props) => {
  const { formatMessage } = useIntlReexport();

  return (
    <NavigationBar.Button
      label={formatMessage(navigationMessages.finishClose)}
      icon={solid('times')}
      {...props}
      finish
    />
  );
};
